import React from "react";
import { media, pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import AdUnit from ".";

const AdWrapper = styled.div`
  min-width: ${pxToRem(122)};
  min-height: ${pxToRem(46)};
  margin-right: -0.5px;

  ${media.mobile} {
    min-width: ${pxToRem(98)};
    min-height: ${pxToRem(37)};
  }
`;

const DriverModalTopAd = React.memo(() => {
  return (
    <AdWrapper>
      <AdUnit id="ad_driver_modal_01" />
    </AdWrapper>
  );
});

export default DriverModalTopAd;
